<template>
    <v-toolbar :color="toolbarColor" dense elevation="1">
        <v-icon left>mdi-file-document-multiple</v-icon>
        <v-toolbar-title>My Applications
        </v-toolbar-title>
    </v-toolbar>
</template>

<script>
export default {
    name: 'my-applications-toolbar',
    props: {
        user: {
            required: true
        }
    },
    computed: {
        toolbarColor() {
            return '#FFA800';
        }
    }
}
</script>